import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Seattle required",
      "Ideal for UM students studying abroad",
      "Great for outdoor industry professionals traveling internationally",
      "Perfect for Bitterroot & Clark Fork Valley residents",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Missoula post offices",
      "Good for planned international travel from MSO",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Missoula County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "Rural Montana mail routing adds 1–2 extra weeks to every timeline",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Montana has zero passport agencies — closest is Seattle (~500 mi, 7.5 hr drive via I-90)",
      "NPIC appointment required before traveling to Seattle",
      "Life-or-death emergencies only — bereavement or medical crisis documentation required",
      "Winter closures on I-90 & mountain passes make ground travel unreliable Oct–April",
      "Expect to wait all day or return next day at the agency",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Missoula"
      headingExtra="MT"
      introText="Missoula travelers — University of Montana students heading abroad, outdoor industry professionals, Clark Fork Valley residents, and western Montanans who know the highway to Seattle isn't exactly a quick trip — have several options for getting a passport fast. Here is how they compare, and why most choose a U.S. Department of State registered passport courier for predictable processing without the 7.5-hour drive."
      options={options}
      emergencyDescription="Montana has zero passport agencies. The closest is Seattle (~500 miles, 7.5+ hours via I-90). Winter closures on mountain passes make ground travel unreliable from October through April, and airline connections from MSO add $300+ to the trip. You must obtain an NPIC appointment before traveling — walk-ins are not accepted."
      disclaimerText="*Processing speed depends on eligibility and documentation. Montana has no regional passport agency — the closest is Seattle, WA (~500 miles). Not all applicants qualify for Regional Agency Processing."
    />
  );
}